import { IAjaxConfig } from '../helpers';
/**
 * https://pcsd-bp-integral-bff-tst.earth.xpaas.lenovo.com/swagger-ui.html#/
 * @export 积分
 * @class EnumApiIntegral
 */
export class EnumApiIntegral {
  /**
   * @dec 积分任务
   */
  readonly integral_task: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/task/querylist',
    loading: true,
  };
  /**
   * @dec 积分任务 sales
   */
  readonly integral_task_sales: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/sales/taskList',
    loading: true,
  };
  /**
   * @dec 积分记录
   */
  readonly integral_record_v2: IAjaxConfig = {
    // url: '/api/gateway/bp-integral/portal/integral/record/querylist',
    url: '/api/gateway/bp-integral/portal/integral/record/org/list',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 积分记录 sales 排行
   */
  readonly integral_sales_rank: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/sales/scoreRank',
    loading: true,
  };
  /**
   * @dec 积分  季度排行
   */
  readonly integral_sales_rank_quarter: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/sales/scoreRankByQuarter',
    loading: true,
  };
  /**
   * @dec 积分 年度排行
   */
  readonly integral_sales_rank_year: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/sales/scoreRankByYear',
    loading: true,
  };
  /**
   * @dec 积分账户（废弃）
   */
  readonly integral_account: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/integral/account/query',
    loading: true,
  };
  /**
   * @dec 积分账户 ISG
   */
  readonly integral_account_v2: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/integral/account/org/query',
    loading: true,
  };

  /**
   * @dec 积分场景枚举v2
   */
  readonly integral_scene_v2: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/integral/scene/org/list',
    loading: true,
  };
  /**
   * @dec 完成 新手任务
   * @p regEx 产品资质  pdf  产品资料  course
   */
  readonly integral_new_task: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/integral/scene/execute',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 全部任务状态
   */
  readonly integral_allTaskStatus_v2: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/task/allTaskStatus',
    // loading: true,
    loading: false,
  };

  /**
   * @dec SMB签到接口
   * @p
   */
  readonly integral_smb_signin: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/integral/scene/execute',
    method: 'post',
  };

  /**
   * @dec SMB 是否已签到接口
   * @p
   */
  readonly integral_smb_getSigninStatus: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/task/getTaskStatusByRuleCode',
    method: 'get',
  };

  /**
   * @dec 学习积分 产品资料接口
   */
  readonly integral_product_view: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/integral/scene/execute',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 过期积分列表查询
   * @method post
   * @params
   */
  readonly integral_record_queryExpireIntegral: IAjaxConfig = {
    url: '/api/gateway/bp-integral/portal/integral/record/queryExpireIntegral',
    method: 'post',
  };
}

// PC端：
// 目前：https://bp-sit.lenovo.com/api/bpportal/integral-bff/v1/integral/account/query
// 替换：https://bp-sit.lenovo.com/api/bpportal/pcsd-bp-integral-bff/v1/integral/account/query
// 小程序，H5：
// 目前：https://tst-bpcentral.lenovo.com.cn/api/bpportal-integral/bpportal-integral-bff/v1/integral/account/query
// 替换：https://tst-bpcentral.lenovo.com.cn/api/bpportal/pcsd-bp-integral-bff/v1/integral/account/query
